export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL';
export const EXECUTE_CONFIRM_COMMAND = 'EXECUTE_CONFIRM_COMMAND';
export const EXECUTE_CONFIRM_COMMAND_STUDENT = 'EXECUTE_CONFIRM_COMMAND_STUDENT';

export function showConfirmation(displayInfo) {
    return {
        type: SHOW_CONFIRM_MODAL,
        payload: {
            displayInfo
        }
    };
}

// The purpose of this defined function is to to avoid directly combining with other components action,
// a try to increase decouple degree.
//
// The Best way is to scheduling another dispatch from within a reducer. Therefore we need to middleware that performs
// asyncDispatch, such as redux-saga. But before using those middleware, here we just simply to execute the command at
// next rendering phase.
//
// Notice: Scheduling another dispatch from within a reducer is NOT an anti-pattern, but
// Starting another dispatch before your reducer is finished is an anti-pattern.
//
export function executeConfirmCommand(commandInfo) {
    return {
        type: EXECUTE_CONFIRM_COMMAND,
        payload: {
            commandInfo
        }
    };
}

export function executeConfirmCommandStudent(commandInfo) {
    return {
        type: EXECUTE_CONFIRM_COMMAND_STUDENT,
        payload: {
            commandInfo
        }
    };
}

export function closeConfirmation(dismissManner) {
    return {
        type: CLOSE_CONFIRM_MODAL,
        payload: {
            dismissManner
        }
    };
}




// WEBPACK FOOTER //
// ./containers/confirmation-modal/confirmation-modal-actions.js